import React from "react";
import withStyles from "components/with-styles";
import styles from "./styles/dashboard-wrapper.css.js";

const DashboardWrapper = ({ classes, children }) => <div className={classes.root}>{children}</div>;

export default withStyles(styles)(DashboardWrapper);
